import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginGuard } from "./guards/login.guard";
import { AuthClienteGuard } from "./guards/authCliente.guard";
import { LoginComponent } from "./pages/login/login.component";
import { LoginComponent as LoginClienteComponent } from "./pages/cliente/login/login.component";
import { LoginClienteGuard } from "./guards/loginCliente.guard";
import { RecoverComponent } from "./pages/recover/recover.component";
import { NewCompilationComponent } from "./pages/new-compilation/new-compilation.component";
import { AuthGuard } from "./guards/auth.guard";
import { PolicyApprovementComponent } from "./pages/policy-approvement/policy-approvement.component";
import { QrCompilationsComponent } from "./pages/qr-compilations/qr-compilations.component";


const routes: Routes = [
  { path: "admin/login", component: LoginComponent, canActivate: [LoginGuard], canActivateChild: [LoginGuard] },
  { path: "recupera", component: LoginComponent, canActivate: [LoginGuard], data: { recover: true } },
  { path: "recupera/:code", component: RecoverComponent, canActivate: [LoginGuard], canActivateChild: [LoginGuard] },
  // Magic-link email: URL `/login/<base64Token>`. Deve essere nel forRoot
  // PRIMA del wildcard `**`, altrimenti viene redirectato a `/` prima che
  // ClienteRoutingModule.forChild possa matcharlo. Il guard legge il token
  // da window.location.href e lo salva in storage → ngOnInit fa auto-login.
  { path: "login/:token", component: LoginClienteComponent, canActivate: [LoginClienteGuard], canActivateChild: [LoginClienteGuard] },
  { path: 'new-compilation/:url', component: NewCompilationComponent },
  { path: 'new-compilation/:url/:idForceManager', component: NewCompilationComponent },
  // ShowValutazioni lazy (porta con sé elabora-questionari → Chart.js/Highcharts/
  // jsPDF fuori dal bundle iniziale). Stesso modulo montato su due prefissi:
  // gli URL pubblici (link email inclusi) restano IDENTICI.
  {
    path: 'valutazioni',
    loadChildren: () =>
      import("./pages/cliente/homepage/licenze/analysis/show-valutazioni.module").then((m) => m.ShowValutazioniModule),
  },
  {
    path: 'questionari/show',
    canActivate: [AuthClienteGuard],
    canActivateChild: [AuthClienteGuard],
    loadChildren: () =>
      import("./pages/cliente/homepage/licenze/analysis/show-valutazioni.module").then((m) => m.ShowValutazioniModule),
  },
  { path: 'policy-utente', component: PolicyApprovementComponent },
  { path: 'user-policy', component: PolicyApprovementComponent },
  { path: "qr-compilations/:url", component: QrCompilationsComponent },
  // Questionario statico RMA: domande hardcoded, nessun guard, salva su
  // `quiz-statici`. Lazy e indipendente dal flow /compilazione.
  {
    path: "rma",
    loadChildren: () => import("./pages/rma/rma.module").then((m) => m.RmaModule),
  },
  {
    path: "public/:qvId",
    loadChildren: () =>
      import("./pages/public-gateway/public-gateway.module").then((m) => m.PublicGatewayModule),
  },
  // Invito diretto survey (Gestione questionari area cliente): stesso gateway.
  {
    path: "public/:qvId/i/:inv",
    loadChildren: () =>
      import("./pages/public-gateway/public-gateway.module").then((m) => m.PublicGatewayModule),
  },
  // Area admin lazy: designer + gestione fuori dal bundle iniziale.
  // `admin/login` resta eager (route statica sopra, matcha prima del prefisso).
  {
    path: "admin",
    loadChildren: () =>
      import("./pages/admin/admin-area.module").then((m) => m.AdminAreaModule),
  },
  // Area cliente + compilazione lazy: i feature module portano i propri
  // forChild, quindi gli URL restano identici (/compilazione/*, /login, /pin,
  // /, /questionari, ...). Deve stare PRIMA del wildcard `**`.
  {
    path: "",
    loadChildren: () =>
      import("./pages/cliente-area.module").then((m) => m.ClienteAreaModule),
  },
  { path: "**", pathMatch: "full", redirectTo: "/" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
